import { css } from 'styled-components';

export const visibleScrollbar = css`
  scrollbar-width: thin;
  scrollbar-color: rgba(75, 70, 79, 0.45) rgba(75, 70, 79, 0.08);
  scrollbar-gutter: stable;

  &::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 10px;
    height: 10px;
    display: block;
  }
  &::-webkit-scrollbar-track {
    background-color: rgba(75, 70, 79, 0.08);
    border-radius: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(75, 70, 79, 0.45);
    border-radius: 5px;
    border: 2px solid transparent;
    background-clip: padding-box;
    min-height: 40px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background-color: rgba(75, 70, 79, 0.65);
    background-clip: padding-box;
  }
  &::-webkit-scrollbar-corner {
    background-color: rgba(75, 70, 79, 0.08);
  }
`;

export const IbmplexsansNormalShark12px = css`
  color: var(--shark);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xs);
  font-weight: 400;
  font-style: normal;
`;
export const IbmplexsansNormalRiverBed14px = css`
  color: var(--river-bed);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xxs);
  font-weight: 400;
  font-style: normal;
`;

export const IbmplexsansNormalShark20px = css`
  color: var(--text);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-m);
  font-weight: 400;
  font-style: normal;
`;

export const IbmplexsansMediumPersianIndigo13px = css`
  color: var(--royal-purple);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xxxs);
  font-weight: 500;
  font-style: normal;
`;

export const IbmplexsansNormalElectricViolet14px = css`
  color: var(--light-mode-purple);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xxs);
  font-weight: 400;
  font-style: normal;
`;

export const IbmplexsansNormalShark20px2 = css`
  color: var(--shark);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-m);
  font-weight: 400;
  font-style: normal;
`;

export const IbmplexsansNormalPersianIndigo13px = css`
  color: var(--royal-purple);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xxxs);
  font-weight: 400;
  font-style: normal;
`;

export const IbmplexsansNormalShark16px = css`
  color: var(--text);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xs);
  font-weight: 400;
  font-style: normal;
`;

export const IbmplexsansNormalMountainMist20px = css`
  color: var(--mountain-mist);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-m);
  font-weight: 400;
  font-style: normal;
`;

export const IbmplexsansNormalElectricViolet16px = css`
  color: var(--light-mode-purple);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xs);
  font-weight: 400;
  font-style: normal;
`;

export const IbmplexsansMediumHorsesNeck13px = css`
  color: var(--horses-neck);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xxxs);
  font-weight: 500;
  font-style: normal;
`;

export const IbmplexsansMediumElectricViolet16px = css`
  color: var(--light-mode-purple);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xs);
  font-weight: 500;
  font-style: normal;
`;

export const IbmplexsansMediumWhite16px = css`
  color: var(--white);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xs);
  font-weight: 500;
  font-style: normal;
`;

export const IbmplexsansSemiBoldRiverBed24px = css`
  color: var(--river-bed);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-l);
  font-weight: 600;
  font-style: normal;
`;

export const IbmplexsansNormalPersianIndigo20px = css`
  color: var(--royal-purple);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-m);
  font-weight: 400;
  font-style: normal;
`;

export const IbmplexsansNormalChicago13px = css`
  color: var(--chicago);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-s);
  font-weight: 400;
  font-style: normal;
`;

export const IbmplexsansNormalWhite20px = css`
  color: var(--white);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-m);
  font-weight: 400;
  font-style: normal;
`;

export const DashboardIbmplexsansNormalWhite20px = css`
  color: var(--white);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xl);
  font-weight: 400;
  font-style: normal;
`;

export const DashboardIbmplexsansBoldWhite72px = css`
  color: var(--white);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xxxxl);
  font-weight: 700;
  font-style: normal;
`;

export const IbmplexsansMediumElectricViolet14px = css`
  color: var(--light-mode-purple);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xxs);
  font-weight: 500;
  font-style: normal;
`;

export const IbmplexsansMediumGreenHouse13px = css`
  color: var(--green-house);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xxxs);
  font-weight: 500;
  font-style: normal;
`;

export const IbmplexsansNormalBlack16px = css`
  color: var(--black);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xs);
  font-weight: 400;
  font-style: normal;
`;

export const IbmplexsansNormalFuscousGray14px = css`
  color: var(--fuscous-gray);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xxs);
  font-weight: 400;
  font-style: normal;
`;

export const IbmplexsansSemiBoldShark24px = css`
  color: var(--text);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-l);
  font-weight: 600;
  font-style: normal;
`;

export const IbmplexsansSemiBoldShark20px = css`
  color: var(--text);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-m);
  font-weight: 600;
  font-style: normal;
`;

export const IbmplexsansMediumWhite13px = css`
  color: var(--white);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xxxs);
  font-weight: 500;
  font-style: normal;
`;

export const IbmplexsansNormalMountainMist16px = css`
  color: var(--mountain-mist);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xs);
  font-weight: 400;
  font-style: normal;
`;

export const IbmplexsansMediumElectricViolet20px = css`
  color: var(--light-mode-purple);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-m);
  font-weight: 500;
  font-style: normal;
`;

export const IbmplexsansMediumRiverBed24px = css`
  color: var(--river-bed);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-l);
  font-weight: 500;
  font-style: normal;
`;

export const IbmplexsansMediumShark36px = css`
  color: var(--text);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xl);
  font-weight: 500;
  font-style: normal;
`;

export const IbmplexsansNormalStack20px = css`
  color: var(--stack);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-m);
  font-weight: 400;
  font-style: normal;
`;

export const IbmplexsansBoldShark64px = css`
  color: var(--dark-purple);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: 64px;
  font-weight: 700;
  font-style: normal;
`;

export const IbmplexsansMediumRiverBed16px = css`
  color: var(--river-bed);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xs);
  font-weight: 500;
  font-style: normal;
`;

export const IbmplexsansMediumCongressBlue13px = css`
  color: var(--congress-blue);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xxxs);
  font-weight: 500;
  font-style: normal;
`;

export const IbmplexsansSemiBoldBlack16px = css`
  color: var(--black);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xs);
  font-weight: 600;
  font-style: normal;
`;

export const IbmplexsansBoldWhite72px = css`
  color: var(--white);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: 72px;
  font-weight: 700;
  font-style: normal;
`;

export const IbmplexsansNormalBlack20px = css`
  color: var(--black);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-m);
  font-weight: 400;
  font-style: normal;
`;

export const IbmplexsansMediumRiverBed32px = css`
  color: var(--river-bed);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: 32px;
  font-weight: 500;
  font-style: normal;
`;

export const IbmplexsansBoldShark36px = css`
  color: var(--dark-purple);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xl);
  font-weight: 700;
  font-style: normal;
`;

export const IbmplexsansNormalPersianIndigo14px = css`
  color: var(--royal-purple);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xxs);
  font-weight: 400;
  font-style: normal;
`;

export const IbmplexsansNormalShark14px = css`
  color: var(--text);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xxs);
  font-weight: 400;
  font-style: normal;
`;

export const IbmplexsansBoldShark36px2 = css`
  color: var(--shark);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xl);
  font-weight: 700;
  font-style: normal;
`;

export const IbmplexsansSemiBoldWhite16px = css`
  color: var(--white);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xs);
  font-weight: 600;
  font-style: normal;
`;

export const IbmplexsansBoldWhite36px = css`
  color: var(--white);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xl);
  font-weight: 700;
  font-style: normal;
`;

export const IbmplexsansNormalWhite14px = css`
  color: var(--white);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xxs);
  font-weight: 400;
  font-style: normal;
`;

export const IbmplexsansMediumRiverBed20px = css`
  color: var(--river-bed);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-m);
  font-weight: 500;
  font-style: normal;
`;

export const IbmplexsansNormalShark18px = css`
  color: var(--shark);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-s);
  font-weight: 400;
  font-style: normal;
`;

export const feedbacksIbmplexsansNormalBlack16px = css`
  color: var(--black);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-s);
  font-weight: 400;
  font-style: normal;
`;

export const feedbacksIbmplexsansMediumWhite16px = css`
  color: var(--white);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-s);
  font-weight: 500;
  font-style: normal;
`;

export const feedbacksIbmplexsansNormalFuscousGray14px = css`
  color: var(--fuscous-gray);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xs);
  font-weight: 400;
  font-style: normal;
`;

export const feedbacksIbmplexsansMediumPersianIndigo20px = css`
  color: var(--royal-purple);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-m);
  font-weight: 500;
  font-style: normal;
`;

export const feedbacksIbmplexsansNormalShark20px = css`
  color: var(--text);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-m);
  font-weight: 400;
  font-style: normal;
`;

export const feedbacksIbmplexsansNormalPersianIndigo13px = css`
  color: var(--royal-purple);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xxs);
  font-weight: 400;
  font-style: normal;
`;

export const feedbacksIbmplexsansNormalPersianIndigo16px = css`
  color: var(--royal-purple);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-s);
  font-weight: 400;
  font-style: normal;
`;

export const feedbacksIbmplexsansMediumBlack16px = css`
  color: var(--black);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-s);
  font-weight: 500;
  line-height: 17px;
  font-style: normal;
`;

export const feedbacksIbmplexsansNormalPersianIndigo20px = css`
  color: var(--royal-purple);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-m);
  font-weight: 400;
  font-style: normal;
`;

export const feedbacksIbmplexsansNormalDeepBronze16px = css`
  color: var(--deep-bronze);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-s);
  font-weight: 400;
  font-style: normal;
`;

export const feedbacksIbmplexsansMediumPersianIndigo16px = css`
  color: var(--royal-purple);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-s);
  font-weight: 500;
  font-style: normal;
`;

export const feedbacksIbmplexsansNormalMountainMist16px = css`
  color: var(--mountain-mist);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-s);
  font-weight: 400;
  font-style: normal;
`;

export const feedbacksIbmplexsansNormalChicago13px = css`
  color: var(--chicago);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xxs);
  font-weight: 400;
  font-style: normal;
`;

export const feedbacksIbmplexsansNormalGraniteGray16px = css`
  color: var(--granite-gray);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-s);
  font-weight: 400;
  font-style: normal;
`;

export const feedbacksIbmplexsansBoldShark36px = css`
  color: var(--dark-purple);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xxl);
  font-weight: 700;
  font-style: normal;
`;

export const feedbacksIbmplexsansNormalStack20px = css`
  color: var(--stack);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-m);
  font-weight: 400;
  font-style: normal;
`;
